import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { DataService } from '../_services/data.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { ForgetPasswordRequest } from '../_model/forgetpassword.request';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-forgetpassword',
    templateUrl: './forgetpassword.component.html',
    styleUrls: ['./forgetpassword.component.sass'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        RouterModule
    ]
})
export class ForgetpasswordComponent implements OnInit {

    forgetPasswordForm = this.formBuilder.group({
        email: ['', [Validators.email, Validators.required]],
    });
    forgetPasswordRequest: ForgetPasswordRequest;
    TIMEOUT_FOR_NAVIGATE = 4000;

    constructor(private formBuilder: FormBuilder,
        private authService: AuthenticationService,
        private router: Router,
        private route: ActivatedRoute,
        private dataService: DataService,
        private toastr: ToastrService) { }

    ngOnInit() {
    }

    navigateToLogin() {
        this.router.navigate(['/login']);
    }

    onSubmit() {
        this.forgetPasswordRequest = {
            email: this.forgetPasswordForm.get('email')?.value ?? ''
        } as ForgetPasswordRequest;
        this.authService.sendPasswordResetMail(this.forgetPasswordRequest).subscribe(response => {
            this.forgetPasswordForm.reset();
            setTimeout(() => this.router.navigate(['/login']), this.TIMEOUT_FOR_NAVIGATE);
        }, error => {
            this.forgetPasswordForm.reset();
            setTimeout(() => this.router.navigate(['/login']), this.TIMEOUT_FOR_NAVIGATE);
            this.toastr.error(error.error.msg, 'Hata');
        });
    }

}
